export const dynamicPricing = {
  title: "Ceny dynamiczne",
  loading: "Wczytywanie ustawień…",
  status: {
    active: "Wł.",
    inactive: "Wył.",
  },
  close: "Zamknij",
  unit: {
    label: "Obiekt",
    autoPill: "✦ Automatycznie na podstawie historii",
  },
  tabs: {
    calendario: "Kalendarz",
    precio: "Cena bazowa",
    reglas: "Reguły",
    aplicacion: "Zastosowanie",
  },
  weekdaysShort: {
    mon: "Pon",
    tue: "Wt",
    wed: "Śr",
    thu: "Czw",
    fri: "Pt",
    sat: "Sob",
    sun: "Nd",
  },
  cal: {
    stats: {
      adr: "Prog. ADR",
      occupancy: "Obłożenie",
      revenue: "Przychód",
    },
    calculating: "Obliczanie cen…",
    minStayShort: "min. {count}n | min. {count}n | min. {count}n",
  },
  legend: {
    low: "Niska",
    base: "Bazowa",
    high: "Wysoka",
    peak: "Szczyt",
    booked: "Zarezerwowane",
    override: "Stała",
  },
  why: {
    title: "Dlaczego {price} {curr} · {day}",
    chip: "wyjaśnienie",
    nights: "{count} noc | {count} noce | {count} nocy",
    minStay: "Minimalny pobyt: {nights} · dolny limit {floor} / górny limit {ceil} {curr}",
    hint: "Kliknij dzień, aby zobaczyć, z czego składa się jego cena.",
  },
  apply: {
    diffPrefix: "Przy sugerowanych cenach:",
    diffSuffix: "w porównaniu z obecnymi cenami na {month}.",
    apply: "Zastosuj ceny",
    applying: "Stosowanie…",
    applyNow: "Zastosuj teraz",
    enableToApply: "Aby zastosować, należy włączyć Ceny dynamiczne.",
    enableFirst: "Najpierw należy włączyć Ceny dynamiczne.",
    autoNote: {
      prefix: "✓ W trybie",
      mode: "Automatycznym",
      mid: "ceny są stosowane",
      everyday: "codziennie",
    },
    result: {
      hotelPending: "Hotele (wiele jednostek) nie są jeszcze obsługiwane na tym etapie.",
      ok: "✓ Zastosowano {count} dzień ({from} → {to}) i wysłano do kanałów. | ✓ Zastosowano {count} dni ({from} → {to}) i wysłano do kanałów. | ✓ Zastosowano {count} dni ({from} → {to}) i wysłano do kanałów.",
      failed: "Nie udało się zastosować cen.",
    },
  },
  base: {
    title: "Cena bazowa i limity",
    desc: "Sugerowane na podstawie historii. Silnik nigdy nie wychodzi poza ten zakres.",
    basePerNight: "Bazowa / noc",
    min: "Minimum (dolny limit)",
    max: "Maksimum (górny limit)",
    rounding: "Zaokrąglanie",
  },
  rounding: {
    integer: "Pełne",
    ends0: "Końcówka 0",
    ends9: "Końcówka 9",
    multiple5: "Wiel. 5",
  },
  weekend: {
    title: "Weekend i minimalny pobyt",
    upliftLabel: "Dopłata weekendowa",
    daysLabel: "Dni weekendowe:",
    minStayLabel: "Minimalny pobyt (noce)",
    minStayNormal: "Standardowy",
    minStayWeekend: "Weekendy / wysoki sezon",
    orphanTitle: "Wypełnij osierocone noce",
    orphanDesc: "Krótsze pobyty ({pct}% zniżki) w lukach 1–2 nocy.",
  },
  demand: {
    title: "Wrażliwość na popyt",
    desc: "W jakim stopniu obłożenie i tempo rezerwacji wpływają na cenę.",
  },
  aggr: {
    low: "Zachowawcza",
    medium: "Średnia",
    high: "Agresywna",
  },
  seasons: {
    title: "Sezony",
    namePlaceholder: "Nazwa",
    monthDayPlaceholder: "MM-DD",
    add: "+ Dodaj sezon",
  },
  events: {
    title: "Wydarzenia (targi, festiwale…)",
    suggestWithAI: "✨ Zaproponuj z AI",
    suggesting: "Szukanie…",
    namePlaceholder: "Nazwa",
    datePlaceholder: "YYYY-MM-DD",
    empty: "Brak wydarzeń. Można je dodać ręcznie lub z pomocą AI.",
    add: "+ Dodaj wydarzenie",
    suggestionsHead: "Sugestie AI{city}: sprawdź daty i dodaj",
    addSuggestion: "+ Dodaj",
    noSuggestions: "Brak sugestii (należy sprawdzić, czy obiekt ma ustawione miasto).",
  },
  demandRules: {
    title: "Reguły popytu",
    lastMinuteTitle: "Zniżki last minute",
    lastMinuteDesc: "Obniża cenę bliskich terminów, które są wciąż wolne.",
    holidaysTitle: "Automatyczne święta",
    holidaysDesc: "Stosuje +{pct}% w święta państwowe.",
    occupancyTitle: "Podwyżka według obłożenia",
    occupancyDesc: "Jeśli miesiąc jest zapełniony w ponad {threshold}%, cena rośnie.",
    weeklyDiscount: "Zniżka tyg. (7+) %",
    monthlyDiscount: "Zniżka mies. (28+) %",
  },
  application: {
    title: "Tryb i synchronizacja",
    modeLabel: "Tryb stosowania",
    modeSuggested: "Sugerowany (najpierw sprawdzam)",
    modeAuto: "Automatyczny",
    syncTitle: "Synchronizacja z kanałami (Channex → Airbnb / Booking)",
    syncDesc: "Publikuje wyliczone ceny w podłączonych kanałach.",
    horizonLabel: "Horyzont obliczeń",
    horizonMonths: "{count} mies.",
  },
  save: {
    saved: "Zapisano ✓",
    saving: "Zapisywanie…",
    save: "Zapisz zmiany",
  },
  errors: {
    forbidden: "Brak dostępu do tego obiektu.",
    loadFailed: "Nie udało się wczytać ustawień.",
    saveFailed: "Nie udało się zapisać. Proszę sprawdzić pola.",
  },
};
